import React, { useState } from 'react';
import { Alert, Stack, TextField } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { createTrailer } from '../../actions/supervisorActions';
import { useAppDispatch, useAppSelector } from '../hooks';

export function CreateTrailerDialog() {
  const dispatch = useAppDispatch();

  const trailersState = useAppSelector((state) => state.trailers);

  const [didFail, setDidFail] = useState(false);

  const [name, setName] = useState<string>('');
  const [nameProblem, setNameProblem] = useState<string | null>(null);
  function validateName(name: string) {
    if (name == null || name.trim() === '') {
      setNameProblem('Name is required');
      return false;
    }

    if (Object.values(trailersState.trailers).some((existingTrailer) => existingTrailer.name === name.trim())) {
      setNameProblem('Trailer with same name already exists');
      return false;
    }

    setNameProblem(null);
    return true;
  }

  async function onSubmit() {
    const nameValidated = validateName(name);
    if (!nameValidated) return;

    setDidFail(false);
    setNameProblem(null);

    try {
      await dispatch(createTrailer(name));
    } catch (error) {
      setDidFail(true);

      console.error(error);

      return;
    }

    dispatch(closeCurrentPopup());
  }

  return (
    <Dialog
      title="Create Trailer"
      submitText="Create"
      onSubmit={onSubmit}
      onCancel="close"
      enterKeySubmits
      submitDisabled={!!nameProblem}
    >
      <Stack spacing={2} sx={{ marginTop: 1 }}>
        {didFail && (
          <Alert variant="outlined" severity="error">
            Unable to create trailer.
          </Alert>
        )}

        <TextField
          autoFocus
          autoComplete="off"
          size="small"
          label="Trailer Name"
          sx={{ marginTop: 1, width: '400px' }}
          value={name}
          error={!!nameProblem}
          onFocus={(event) => event.target.select()}
          onChange={(event) => {
            setName(event.target.value);
            validateName(event.target.value);
          }}
        />

        {nameProblem && (
          <Alert variant="outlined" severity="error">
            {nameProblem}
          </Alert>
        )}
      </Stack>
    </Dialog>
  );
}
